// Is the page running inside our Android app (the Trusted Web Activity,
// apps/android)? Chrome opens it with the app as the referrer
// ("android-app://io.achtungroyale.app/"), on the first page only: after that
// the referrer is the site itself, so the answer is kept for the session. The
// app also opens the site at "/?app=android" (twa-manifest.json startUrl, from
// app version 1.0.2), the surer sign of the two.
const KEY = "ar.androidApp";
let cached: boolean | null = null;

export function inAndroidApp(): boolean {
  if (cached !== null) return cached;
  let yes = false;
  try {
    yes = typeof document !== "undefined" && (document.referrer.indexOf("android-app://io.achtungroyale.app") === 0 || new URLSearchParams(location.search).get("app") === "android");
    if (yes) sessionStorage.setItem(KEY, "1");
    else yes = sessionStorage.getItem(KEY) === "1";
  } catch { /* no storage: the referrer alone */ }
  cached = yes;
  return yes;
}

// The app's screen height, held steady. Android shows its gesture bar for a
// moment when you start the swipe to the app switcher, and the page's visible
// height shrinks with it, so everything sized to the screen jumped a little.
// In the app, --app-h holds the tallest height seen at this width; layouts use
// var(--app-h, 100dvh). A new width (a fold, a turn) takes a fresh measure.
export function startAppViewport(): void {
  if (typeof window === "undefined" || !inAndroidApp()) return;
  let width = 0, height = 0;
  const measure = () => {
    const w = window.innerWidth, h = window.innerHeight;
    if (w !== width) { width = w; height = h; } else height = Math.max(height, h);
    document.documentElement.style.setProperty("--app-h", height + "px");
  };
  measure();
  window.addEventListener("resize", measure);
}
